import { render, staticRenderFns } from "./mydiscuss.vue?vue&type=template&id=a8144da8&scoped=true"
import script from "./mydiscuss.vue?vue&type=script&lang=js"
export * from "./mydiscuss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8144da8",
  null
  
)

export default component.exports